import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DataStateItem } from 'shared/types';
import { InitialTableStateType } from '../../types/appTypes';

export interface SelectedRow {
  tableEntityName: string
  selectedRow: DataStateItem;
}

const initialState: InitialTableStateType = {};

export const appTableSlice = createSlice({
  name: 'appTable',
  initialState,
  reducers: {
    setSelectedRow: (state, action: PayloadAction<SelectedRow>) => {
      const { tableEntityName, selectedRow } = action.payload;
      state[tableEntityName] = selectedRow;
    },
  },
});

export const { actions: appTableActions } = appTableSlice;
